import React from "react";

import { Grid, Typography, Hidden, Button } from "@material-ui/core";
import { constantsApp } from "../../../constants/constants.app";

export default ({ toggleForm }) => {
  return (
    <Grid
      container
      alignContent="center"
      alignItems="center"
      justify="space-between"
    >
      <Typography variant="h4" gutterBottom>
        {constantsApp.layouts.headers.admin.TITLE}
      </Typography>
      <Hidden smDown>
        <Button
          variant="contained"
          color="primary"
          size="large"
          onClick={() => toggleForm("showFormCommunity")}
        >
          {constantsApp.layouts.headers.admin.ADD_COMMUNITY_BUTTON}
        </Button>
      </Hidden>
    </Grid>
  );
};
